<template>
   <!-- class割当用 --> 
  <div>  
     <!-- Wrapperレイヤは省略 -->        
     <!-- 非活性レイヤー -->    
    <div class="cx_layer" v-if="place || value || visible" :style="{zIndex:zIndex, display:value || visible ? display:'none'}">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

//BootStrap.vueのモーダルの置き換えなどに使用できるzIndexのみを管理するベースレイヤーを提供します。

@Component
export default class Window extends Vue {
  @Prop({ default: false }) public value : boolean; //v-model
  @Prop({ default: false }) public visible : boolean;  //固定表示用
  @Prop({ default: false }) public place : boolean;  //非表示状態でタグを配置する場合はtrueをセット
  @Prop({ default: false, type:Boolean }) public block : boolean;  //Bootstrap.vueはblock表示

  public baseIndex = 950;
  public offset = 100;
  public zIndex = this.baseIndex;

  public get display() { return this.block ? 'block':'flex';}
  public mounted(){
    this.onValueChanged();
  }
 @Watch('value')
  public onValueChanged(){
      if (this.value) {          
        this.zIndex = Math.max(this.baseIndex,this.$api.getMaxZIndex()) + this.offset;        
      } else {
        this.zIndex = this.baseIndex; //zIndexをリセット
      }
  }
}
</script>
<style lang="scss">
  .cx_layer{
      position:fixed;
      top:0;
      left:0;
      width:100%;
      height:100%;
      background-color: rgba(107, 107, 107, 0.308);
      display:flex;
      justify-content: center;
      align-items: center;
  }
  </style>